import React from 'react';
import {Helmet} from "react-helmet";
import {useTranslation} from 'react-i18next';

import Modals from './Modals';
import Layout from './Layout';

const WrappingComponents = (props) => {
    const {t} = useTranslation();
    return <>
        <Helmet
            defaultTitle={t('WrappingComponents.default-title')}
            titleTemplate={t('WrappingComponents.title-template')}
        >
            {/* <meta name="robots" content="noindex" /> */}
        </Helmet>
        <Modals />
        <Layout>
            {props.children}
        </Layout>
    </>
}

export default WrappingComponents;
